import React from 'react';
import cta1 from '../../assets/cta1.png';
import cta2 from '../../assets/cta2.png';
import under from '../../assets/needle-underline.svg';
import { Link } from 'react-router-dom';

function CTA() {
    return (
        <div
            className="bg-second max-w-[80rem] px-4 sm:px-8 mx-auto rounded-3xl h-auto sm:h-[50vh] bg-cover bg-center p-6 sm:p-8 flex flex-col sm:flex-row items-center sm:justify-between gap-6"
            style={{ backgroundImage: `url(${cta1})` }}
        >
            <div className="text-center sm:text-left">
                <h1 className="mt-2 sm:mt-5 text-2xl sm:text-5xl lg:text-6xl font-light text-primary">
                    <span className="relative inline-block">
                        <span className="absolute inset-0 transform -rotate-2 z-0" />
                        <span className="relative z-10 font-bold px-2 py-1 text-primary">
                            Let’s Talk on Your Project
                        </span>
                        <img src={under} alt="underline" className="mx-auto sm:mx-0" />
                    </span>
                </h1>
                <Link to='/contact'>
                    <button className="relative mt-6 sm:mt-8 rounded-lg border-2 border-blue-700 bg-primary px-10 sm:px-16 py-3 sm:py-4 text-white transition hover:translate-y-1">
                        <div className="-scale-x-100 absolute left-2 -bottom-10 hidden sm:inline-flex h-10 w-10 -rotate-12 text-blue-700">
                            <svg viewBox="0 0 82 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {/* SVG Path here */}
                            </svg>
                        </div>
                        Contact Us
                    </button>
                </Link>
            </div>
            <img src={cta2} alt="illustration" className="w-36 sm:w-52" />
        </div>
    );
}

export default CTA;
